export default function () {
  this.setSchedules()
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/preview/resources/mounted.js